<template>
  <div>
    <el-form ref="formRef" :model="marriageForm" label-width="160px">
      <el-form-item label="红娘名称：">
        <el-input type="text" v-model="marriageForm.name" placeholder="请输入红娘名称" style="width:24em;"/>
      </el-form-item>
      <el-form-item label="微信号：">
        <el-input type="text" v-model="marriageForm.wechat" placeholder="请输入微信号" style="width:24em;"/>
      </el-form-item>
      <el-form-item label="权重：">
        <el-input type="text" v-model="marriageForm.weight" placeholder="请输入正整数" style="width:24em;"/>
        <p><span style="color: red">*</span>权重越高，越优先展示给用户</p>
      </el-form-item>
      <el-form-item label="展示位置：">
        <el-select v-model="type" placeholder="请选择" style="width: 24em">
          <el-option v-for="item in typeArray" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="当天被复制上限：">
        <el-input type="text" v-model="marriageForm.dayCopyCeiling" placeholder="请让输入上限数" style="width:24em;"/>
      </el-form-item>
      <el-form-item label="" ></el-form-item>
      <el-form-item label="用户可见的条件"></el-form-item>
      <el-form-item label="性别：">
        <el-select v-model="sex" value-key="value" placeholder="请选择"  style="width: 11em;">
          <el-option v-for="item in sexArray" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="婚姻：">
        <el-select v-model="marryState" value-key="value" placeholder="请选择"  style="width: 11em;">
          <el-option v-for="item in marriageArray" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="年龄：">
        <el-select v-model="ageMin" placeholder="请选择" filterable style="width: 11em;">
          <el-option v-for="item in ageArray" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        &nbsp;-&nbsp;
        <el-select v-model="ageMax" placeholder="请选择" filterable style="width: 11em;">
          <el-option v-for="item in ageArray" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="月收入：">
        <el-select v-model="salaryMin" placeholder="请选择" filterable style="width:  11em;">
          <el-option v-for="item in salaryArray" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        &nbsp;-&nbsp;
        <el-select v-model="salaryMax" placeholder="请选择" filterable style="width: 11em;">
          <el-option v-for="item in salaryArray" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="身高：">
        <el-select v-model="heightMin" placeholder="请选择" filterable style="width: 11em;">
          <el-option v-for="item in heightArray" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        &nbsp;-&nbsp;
        <el-select v-model="heightMax" placeholder="请选择" filterable style="width: 11em;">
          <el-option v-for="item in heightArray" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="学历：">
        <el-select v-model="educationMin" placeholder="请选择" filterable style="width: 11em;">
          <el-option v-for="item in educationArray" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        &nbsp;-&nbsp;
        <el-select v-model="educationMax" placeholder="请选择" filterable style="width: 11em;">
          <el-option v-for="item in educationArray" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div class="dialog-footer" style="text-align: center;">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit" v-loading="loading">确定</el-button>
    </div>
  </div>

</template>

<script>
import { postFormData } from "@/api/api"
import { addOrUpdateMarriageWeChat } from "@/api/url";
import { positiveIntReg } from "../../../assets/shared/reg-constant";

export default {
  name: "MarriageEditDialog",
  props: {
    value: Object
  },
  data() {
    return {
      marriageForm: this.value.marriageForm,
      idx: this.value.ids,
      loading: false,

      typeArray: [
        {label: '全部', value: 0},
        {label: '一对一脱单服务', value: 1},
        {label: '加微信领金币', value: 2},
      ],
      type: this.value.marriageForm.type?this.value.marriageForm.type:0,

      //性别
      sexArray: [
        {label: '不限', value: -1},
        {label: '男', value: 1},
        {label: '女', value: 2}
      ],
      sex: this.value.marriageForm.sex?this.value.marriageForm.sex: -1,

      //婚姻
      marriageArray: [
        {label: '不限', value: -1},
        {label: '未婚', value: 1},
        {label: '离异', value: 2},
        {label: '丧偶', value: 3}
      ],
      marryState: this.value.marriageForm.marryState?this.value.marriageForm.marryState: -1,

      // 身高
      heightArray: [
        {label: '不限', value: -1}
      ],
      heightMin: this.value.marriageForm.heightMin?this.value.marriageForm.heightMin: -1,
      heightMax: this.value.marriageForm.heightMax?this.value.marriageForm.heightMax: -1,

      // 收入
      salaryArray: [
        {label: '不限', value: -1}
      ],
      salaryMin: this.value.marriageForm.salaryMin?this.value.marriageForm.salaryMin: -1,
      salaryMax: this.value.marriageForm.salaryMax?this.value.marriageForm.salaryMax: -1,

      // 年龄
      ageArray: [
        {label: '不限', value: -1}
      ],
      ageMin: this.value.marriageForm.ageMin?this.value.marriageForm.ageMin: -1,
      ageMax: this.value.marriageForm.ageMax?this.value.marriageForm.ageMax: -1,

      // 学历
      educationArray: [
        {label: '不限', value: -1},
        {label: '初中', value: 1},
        {label: '中专/职高/技校', value: 2},
        {label: '高中', value: 3},
        {label: '大专', value: 4},
        {label: '本科', value: 5},
        {label: '硕士', value: 6},
        {label: '博士', value: 7},
        {label: '博士后', value: 8},
      ],
      educationMin: this.value.marriageForm.educationMin?this.value.marriageForm.educationMin: -1,
      educationMax: this.value.marriageForm.educationMax?this.value.marriageForm.educationMax: -1,

    }
  },
  methods: {
    cancel() {
      this.$emit("close");
    },

    // 身高
    getHeight() {
      let arr = [];
      for(let i = 145; i <= 200; i++) {
        arr.push({label : i + 'cm', value : i})
      }
      this.heightArray = this.heightArray.concat(arr);
    },

    // 年龄
    getAge() {
      let arr = [];
      for(let i = 18; i <= 80; i++) {
        arr.push({label : i , value : i})
      }
      this.ageArray = this.ageArray.concat(arr);
    },

    // 收入
    getInCome() {
      let arr = [];
      for(let i = 2; i <= 50; i++) {
        arr.push({label : i + 'k', value : i})
      }
      this.salaryArray = this.salaryArray.concat(arr);
    },

    //更改或添加
    headImgUpdate() {
      this.$refs.headImg.click();
    },

    //选取图片
    headImgChanged(e) {
      if(e.target.files[0]) {
        this.files = e.target.files[0];
        var windowURL = window.URL || window.webkitURL;
        this.src = windowURL.createObjectURL(this.files);
      }
    },

    summit() {
      if(!this.marriageForm.name) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: "红娘名称不能为空",
          type: 'warning'
        });
        return;
      }
      if(!this.marriageForm.wechat) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: "微信号不能为空",
          type: 'warning'
        });
        return;
      }
      if(!this.marriageForm.weight) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: "权重不能为空",
          type: 'warning'
        });
        return;
      }
      if(!positiveIntReg.test(this.marriageForm.weight)) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: "权重不能为空",
          type: 'warning'
        });
        return;
      }
      this.loading = true
      let param = {};
      param['id'] = this.marriageForm.id?this.marriageForm.id:0;
      param['name'] = this.marriageForm.name;
      param['wechat'] = this.marriageForm.wechat;
      param['weight'] = this.marriageForm.weight;
      param['dayCopyCeiling'] = this.marriageForm.dayCopyCeiling;
      param['type'] = this.type;
      param['sex'] = this.sex;
      param['marryState'] = this.marryState;
      param['ageMin'] = this.ageMin;
      param['ageMax'] = this.ageMax;
      param['heightMin'] = this.heightMin;
      param['heightMax'] = this.heightMax;
      param['salaryMin'] = this.salaryMin;
      param['salaryMax'] = this.salaryMax;
      param['educationMin'] = this.educationMin;
      param['educationMax'] = this.educationMax;
      postFormData(addOrUpdateMarriageWeChat, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm')
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
        this.loading = false
      }).catch(()=>{
        this.loading = false
      })
    }
  },
  mounted() {
    this.getHeight();
    this.getAge();
    this.getInCome();
  }
}
</script>

<style scoped>
.add {
  width: 80px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  border: 1px dashed #ececec;
  font-size: 30px;
  cursor: pointer;
  float: left;
}
</style>
